export default {
  MemberList: require('./MemberList').default,
  DataPointList: require('./DataPointList').default
}